import * as React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';
import { KeyDate } from 'routes/Home/models/KeyDate';
import DatePicker from 'components/inputs/DatePicker';
import { Skeleton } from '@mui/material';
import { getFormattedScheduledDate, getKeyDateLabel } from './helpers';

type Props = {
    keyDate: KeyDate | undefined;
    isEditing: boolean;
    onDateChange: (date: string, event: string, exercice: string) => void;
    error: string | undefined;
    exercice: string;
};

const BudgetKeyDateLabel = ({
    keyDate,
    isEditing,
    onDateChange,
    error,
    exercice,
}: Props): JSX.Element => {
    const { t } = useTranslation();

    if (!keyDate) {
        return (
            <Flex align="center" direction="column">
                <Skeleton variant="text" sx={{ fontSize: '2rem' }} width={80} />
            </Flex>
        );
    }

    return (
        <Flex align="center" direction="column">
            <Typography>{getKeyDateLabel(keyDate, t)}</Typography>
            {isEditing ? (
                <DatePicker
                    value={keyDate.scheduledAt}
                    onChange={(date: string) =>
                        onDateChange(date, keyDate.event, exercice)
                    }
                    error={!!error}
                    helperText={error}
                    applyDefaultValueIfNull={false}
                />
            ) : (
                <Typography
                    sx={{
                        fontStyle: 'italic',
                        fontSize: '12px',
                    }}
                >
                    {getFormattedScheduledDate(keyDate.scheduledAt, t)}
                </Typography>
            )}
        </Flex>
    );
};

export default BudgetKeyDateLabel;
